module.exports = __webpack_public_path__ + "static/media/slider-img1.4d3f35a1.jpg";